import { SingleResponse } from "@/src/core/response"
import OrderGet from "@/src/interfaces/sales/order-get"
import OrderPost from "@/src/interfaces/sales/order-post"
import { sendRequest } from "@/src/core/http-client"

export class OrderService {
    /** Retorna os pedidos do cliente. */
    static async getOrders(param: OrderGet.OrdersParams, accessToken?: string): Promise<SingleResponse<OrderGet.OrdersResponse>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_SALES_URL}/orders`

        const params = new URLSearchParams()

        params.append('Page', `${param.page ?? 1}`)
        params.append('PageSize', `${param.pageSize ?? 10}`)

        if (param.merchantId) params.append('MerchantId', param.merchantId)
        if (param.customerId) params.append('CustomerId', param.customerId)
        if (param.orderId) params.append('OrderId', param.orderId)
        if (param.sortingColumn) params.append('SortingColumn', param.sortingColumn)
        if (param.sortingDirection) params.append('SortingDirection', param.sortingDirection)

        const finalUrl = `${baseUrl}?${params.toString()}`

        return sendRequest<OrderGet.OrdersResponse>(undefined, finalUrl, 'GET', undefined, accessToken)
    }

    /** Retorna os dados completos sobre o pedido. */
    static async getOrder(orderId: string, appAccessToken?: string, accessToken?: string): Promise<SingleResponse<OrderGet.Response>> {
        return sendRequest<OrderGet.Response>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_SALES_URL}/orders/${orderId}`,
            'GET',
            undefined,
            accessToken
        )
    }

    /** Retorna o status do andamento do pedido. */
    static async getStatus(orderId: string, accessToken?: string): Promise<SingleResponse<OrderGet.StatusResponse>> {
        return sendRequest<OrderGet.StatusResponse>(
            undefined,
            `${process.env.NEXT_PUBLIC_SALES_URL}/orders/${orderId}/status`,
            'GET',
            undefined,
            accessToken
        )
    }

    /** Retorna dados para conferir se o chat é habilitado para o pedido. */
    static async getChatPermission(param: OrderGet.ChatPermissionParams, appAccessToken?: string, accessToken?: string): Promise<SingleResponse<OrderGet.ChatPermissionResponse>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_SALES_URL}/orders/${param.orderId}/chats/permission`

        const params = new URLSearchParams()

        if (param.merchantId) params.append('MerchantId', param.merchantId)
        if (param.customerId) params.append('CustomerId', param.customerId)

        const finalUrl = `${baseUrl}?${params.toString()}`

        return sendRequest<OrderGet.ChatPermissionResponse>(appAccessToken, finalUrl, 'GET', undefined, accessToken)
    }

    /** Envia o pedido para o PDV. */
    static async sendOrder(request: OrderPost.Request, appAccessToken?: string, accessToken?: string): Promise<SingleResponse<OrderPost.Response>> {
        return sendRequest<OrderPost.Response>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_SALES_URL}/orders`,
            'POST',
            request,
            accessToken
        )
    }

    static async sendOrderRating(request: OrderPost.RatingRequest, appAccessToken?: string): Promise<SingleResponse<OrderPost.Response>> {
        return sendRequest<OrderPost.Response>(
            appAccessToken,
            `${process.env.NEXT_PUBLIC_SALES_URL}/orders/${request.orderId}/rating`,
            'PUT',
            request
        )
    }
}